const MONEY_BUTTON_JS_URL = 'https://www.moneybutton.com/moneybutton.js';
let onlyOneExecution = null;

const loadMoneyButtonJs = async ({
  url = MONEY_BUTTON_JS_URL
} = {}) => {
  if (onlyOneExecution !== null) {
    return onlyOneExecution;
  }

  const promise = new Promise(resolve => {
    if (typeof window === 'undefined') {
      throw new Error('This library is meant to use in the browser');
    }

    if (window.moneyButton) {
      return resolve(window.moneyButton);
    }

    const aScript = document.createElement('script');
    aScript.type = 'text/javascript';
    aScript.src = url;
    document.head.appendChild(aScript);

    aScript.onload = () => {
      resolve(window.moneyButton);
    };
  });
  onlyOneExecution = promise;
  return promise;
};

export { loadMoneyButtonJs };
//# sourceMappingURL=moneybutton-loader.esm.js.map
